import { Box, BoxProps } from '@wegroup/design-system';
import React from 'react';

interface Props {
  show?: boolean;
}

const Blur: React.FC<React.PropsWithChildren<Props & BoxProps>> = ({
  show,
  ...props
}) => {
  return (
    <Box
      opacity={show ? 1 : 0}
      transition="opacity 0.2s"
      backdropFilter="blur(10px)"
      w="100%"
      h="100%"
      pointerEvents="none"
      {...props}
    />
  );
};

export default Blur;
